// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ho-0";